import { render, staticRenderFns } from "./WorkflowView.vue?vue&type=template&id=0a6a7430&"
import script from "./WorkflowView.vue?vue&type=script&lang=js&"
export * from "./WorkflowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports